export default __webpack_public_path__ + "static/secure-infrastructure-94fc3400665e65a864bc8faef41d97c9.svg";